<template>
  <div class="h-top">
    <!-- <fix-top /> -->
    <div v-if="isPc">
      <div
        class="header"
        :style="'background-color:rgba(255, 255, 255,' + o + ')'"
      >
        <router-link :to="{ path: '/' }">
          <img class="logo" src="@/assets/images/index-logo.png" />
        </router-link>
        <el-menu
          :default-active="onRoutes"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          background-color="transtrent"
          text-color="#2C2C2E"
          active-text-color="#005BAC"
        >
          <el-menu-item
            v-for="(item, index) in navMenu"
            :key="item.title"
            :index="item.to"
            :route="`${item.to}`"
            :disabled="index == 4"
          >
            <!-- {{ item.title }} -->
            <a v-if="index == 4" :href="item.to" target="_blank">
              {{ item.title }}
            </a>
            <span v-else>{{ item.title }}</span>
          </el-menu-item>
        </el-menu>
        <div class="lan">
          <span class="active little_hand">中文</span>
          <span>/</span>
          <router-link :to="{ path: '/en_index' }">
            <span class="little_hand">English</span>
          </router-link>
        </div>
      </div>
    </div>
    <div class="mobile" v-else>
      <div
        class="menu-icon justify-between items-center"
        :style="'background-color:rgba(255, 255, 255,' + o + ')'"
      >
        <img class="logo" src="@/assets/images/index-logo.png" />
        <img
          class="menu"
          src="@/assets/images/menu.png"
          @click="drawer = true"
        />
      </div>
      <el-drawer
        title=""
        append-to-body
        :visible.sync="drawer"
        :direction="direction"
      >
        <el-menu
          :default-active="onRoutes"
          class="el-menu-demo"
          router
          @select="handleSelect"
          background-color="transtrent"
          text-color="#2C2C2E"
          active-text-color="#005BAC"
        >
          <!-- <el-menu-item
            v-for="item in navMenu2"
            :key="item.title"
            :index="item.to"
          >
            {{ item.title }}
          </el-menu-item> -->
          <el-menu-item
            v-for="(item, index) in navMenu2"
            :key="item.title"
            :index="item.to"
            :route="`${item.to}`"
            :disabled="index == 5"
          >
            <!-- {{ item.title }} -->
            <a v-if="index == 5" :href="item.to" target="_blank">
              {{ item.title }}
            </a>
            <span v-else>{{ item.title }}</span>
          </el-menu-item>
        </el-menu>
        <div class="lan">
          <span class="active little_hand">中文</span>
          <span>/</span>
          <router-link :to="{ path: '/en_index' }">
            <span class="little_hand" @click="drawer = false">English</span>
          </router-link>
        </div>
      </el-drawer>
    </div>
    <!-- <fix-bg v-if="isPc" /> -->
    <!-- <award /> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import Vue from "vue";

export default {
  components: {},
  data() {
    return {
      navMenu: [
        {
          title: "关于冠龙",
          to: "/about",
        },
        {
          title: "产品系列",
          to: "/products",
        },
        {
          title: "新闻中心",
          to: "/news",
        },
        {
          title: "联系我们",
          to: "/contact",
        },
        {
          title: "投资者关系",
          to: "https://ir.p5w.net/c/301151.shtml",
        },
      ],
      navMenu2: [
        {
          title: "首页",
          to: "/index",
        },
        {
          title: "关于冠龙",
          to: "/about",
        },
        {
          title: "产品系列",
          to: "/products",
        },
        {
          title: "新闻中心",
          to: "/news",
        },
        {
          title: "联系我们",
          to: "/contact",
        },
        {
          title: "投资者关系",
          to: "https://ir.p5w.net/c/301151.shtml",
        },
      ],
      drawer: false,
      direction: "rtl",
      o: 0,
      scrollTop: 0,
    };
  },
  computed: {
    ...mapState(["isPc", "validToken", "userInfo", "user_id"]),
    onRoutes() {
      // 已改写成只需匹配到一级路由即可匹配菜单
      return this.$route.matched[1].path;
    },
  },
  methods: {
    handleSelect(key, keyPath) {
      if (key == "/personal" && !this.validToken) {
        this.$router.push({
          path: `/login`,
        });
        return false;
      } else {
        this.$router.push({
          path: key,
        });
      }
      console.log(key == "/personal", !this.validToken);
      this.drawer = false;
    },
    handleScroll() {
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.o = this.scrollTop / 600;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
};
</script>

<style rel="stylesheet/scss" lang="scss"  scoped>
.header {
  // background: linear-gradient(360deg, rgba(0, 0, 0, 0) 0%, rgba(0,0,0,.64) 100%);
  padding: 20px 40px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 26;
  width: 100%;
  display: flex;
  align-items: center;
  min-width: 1360px;
  .logo {
    width: 300px;
  }
  .lan {
    padding-left: 32px;
    border-left: 1px solid #d8d8d8;
    height: fit-content;
    display: flex;
    margin-left: 20px;
    span {
      font-size: 18px;
      font-family: MicrosoftYaHei;
      // color: rgba($color: #ffffff, $alpha: 0.32);
      color: #c7c7cc;
      line-height: 28px;
      margin-left: 8px;
    }
    .active {
      // color: #ffffff;
      color: #2c2c2e;
    }
  }
  .el-menu {
    background: transparent;
    flex: 1;
  }
  .el-menu-demo {
    display: flex;
    justify-content: flex-end;
    margin: auto;
    position: relative;
    z-index: 6;
  }

  .el-menu--horizontal > .el-menu-item {
    height: 44px;
    line-height: 44px;
    font-family: "MicrosoftYaHeiLight";
    font-size: 22px;
    color: #ffffff;
    letter-spacing: 4px;
    text-align: center;
    font-weight: 500;
    padding: 0 20px;
    border: none;
    background-color: transparent !important;
    font-weight: bolder;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .el-menu--horizontal > .el-menu-item:hover {
    background-color: transparent !important;
    font-weight: bolder;
  }
  .el-menu::after,
  .el-menu::before {
    content: none;
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    border: none;
    font-weight: bolder;
    color: #127b7b;
  }
  .el-menu.el-menu--horizontal {
    border-bottom: none;
  }
}
.bg {
  width: 100%;
  height: 100px;
  // height: 137px;
  // background: url("https://api2.ts960.com/cyshj/assets/images/banner01.png") no-repeat center bottom;
  background-size: cover;
  // background: #e43d3f;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 15;
}
.empty {
  width: 100%;
  height: 137px;
}
.mobile {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 26;
  width: 100%;
  box-sizing: border-box;
  .menu-icon {
    padding: 10px 20px;
    height: 80px;
    // background: linear-gradient(
    //   360deg,
    //   rgba(0, 0, 0, 0) 0%,
    //   rgba(0, 0, 0, 0.64) 100%
    // );
    opacity: 0.64;
    z-index: 30;
    position: relative;
    .logo {
      width: 180px;
      height: auto;
      object-fit: contain;
    }
    .menu {
      width: 20px;
      height: 20px;
      object-fit: contain;
      padding: 10px;
      border-radius: 100%;
      background: rgba($color: #000000, $alpha: 0.4);
      box-sizing: content-box;
    }
  }
}
</style>
<style >
.el-menu-item.is-disabled {
  opacity: 1 !important;
  display: flex;
  align-items: center;
}
.el-menu-item.is-disabled a {
  color: rgb(44, 44, 46);
  line-height: 25px;
}
.el-drawer {
  width: 52% !important;
  background-color: #ffffff;
}
.el-drawer .lan {
  position: fixed;
  bottom: 0;
  padding: 40px 0;
  width: 52%;
  text-align: center;
  border-top: 1px solid #e5e5ea;
}
.el-drawer .lan span {
  font-size: 16px;
  font-family: MicrosoftYaHei;
  color: rgba(0, 0, 0, 0.32);
  line-height: 22px;
}
.el-drawer .lan span.active {
  color: #000000;
}
.el-drawer__body .el-menu {
  background: transparent;
}
.el-drawer__body .el-menu-demo {
  margin: auto;
  padding: 0 27px;
  position: relative;
  z-index: 6;
  margin-top: 50px;
}
.el-drawer__body .el-menu-item {
  height: 44px;
  line-height: 44px;
  font-family: "MicrosoftYaHeiLight";
  font-size: 18px;
  color: #ffffff;
  letter-spacing: 4px;
  text-align: center;
  font-weight: 500;
  padding: 0 !important;
  border: 2px solid transparent;
  background-color: transparent !important;
  font-weight: bolder;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-drawer__body .el-menu-item:hover {
  background-color: transparent !important;
  font-weight: bolder;
}
.el-drawer__body .el-menu::after,
.el-drawer__body .el-menu::before {
  content: none;
}

.el-drawer__body .el-menu {
  border-bottom: none;
}
.el-drawer__close-btn {
  color: #2c2c2e;
  font-size: 32px;
  background-color: rgba(255, 255, 255, 0.12);
  padding: 10px;
  border-radius: 44px;
  display: flex;
}
</style>


// WEBPACK FOOTER //
// src/views/common/Header.vue